import { create } from 'zustand';
import { setAuthToken, removeAuthToken } from './browser_state';

const readToken = () => localStorage.getItem('authToken');

export const useAuthStore = create((set) => ({
    token: readToken(),
    isAuthenticated: !!readToken(),

    login: async (token) => {
        await setAuthToken(token);
        set({ token, isAuthenticated: true });
    },

    logout: async () => {
        await removeAuthToken();
        set({ token: null, isAuthenticated: false });
    },

    refresh: () => {
        const token = readToken();
        set({ token, isAuthenticated: !!token });
    },
}));
